import React, { Component } from 'react';
import { connect } from 'react-redux';

import { toggleGoogleInviteModal } from 'actions/google';

import InvitePane from './invite-pane';
import PermissionPane from './permission-pane';
import SuccessPane from './success-pane';
import { hasGoogleAppScopes } from '../../../../shared/utilities/google';

import './styles.less';

const GoogleInviteModal = class extends Component {
  render() {
    const { user, google: gInfo } = this.props;
    const { oauth } = user || {};
    const { google } = oauth || {};
    const googleScopes = google && google.scopes;
    const hasPermissions = hasGoogleAppScopes(googleScopes);

    if (!google) {
      return null;
    }

    if (!hasPermissions) {
      return <PermissionPane error={gInfo.oauth_error} />;
    }

    if (gInfo.invite_success) {
      return <SuccessPane />;
    }

    return <InvitePane />;
  }
};

const mapStateToProps = state => {
  const { google, user } = state;

  return {
    google,
    user: user.current,
    source: google.invite_modal_source,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleGoogleInviteModal: show => dispatch(toggleGoogleInviteModal(show)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GoogleInviteModal);
